import React from 'react';

import { State } from '../state/types';

import { ContactDetailsStep } from './ContactDetailsStep/ContactDetailsStep';
import { TroubleShootingOne } from './TroubleShootingStep/TroubleShootingOne';
import { TroubleShootingTwo } from './TroubleShootingStep/TroubleShootingTwo';
import { ArrivalStep } from './ArrivalStep';
import { CategoryStep } from './CategoryStep';
import { ConfirmBookingStep } from './ConfirmBookingStep';
import { DescriptionStep } from './DescriptionStep';
import { ServiceStep } from './ServiceStep';

type StepNames = [
  'categories',
  'services-troubleshooting-one',
  'services-troubleshooting-two',
  'services',
  'description',
  'contact-details',
  'booking',
  'confirmation'
];

export type StepMap = {
  [key: number]: {
    component: (<P extends Record<string, unknown>>(props: P) => JSX.Element) | React.FunctionComponent;
    displayedStep: number;
    isNextButtonDisabled: boolean | ((state: State) => boolean);
    name: StepNames[number];
  };
};

export const HOMEOWNER_FLOW_FIRST_STEP = 1;

export const HOMEOWNER_FLOW_STEP_MAP: StepMap = {
  [HOMEOWNER_FLOW_FIRST_STEP]: {
    component: CategoryStep,
    displayedStep: 1,
    isNextButtonDisabled: true,
    name: 'categories',
  },
  2: {
    component: ServiceStep,
    displayedStep: 1,
    isNextButtonDisabled: true,
    name: 'services',
  },
  3: {
    component: TroubleShootingOne,
    displayedStep: 2,
    isNextButtonDisabled: false,
    name: 'services-troubleshooting-one',
  },
  4: {
    component: TroubleShootingTwo,
    displayedStep: 2,
    isNextButtonDisabled: false,
    name: 'services-troubleshooting-two',
  },
  5: {
    component: DescriptionStep,
    displayedStep: 2,
    isNextButtonDisabled: false,
    name: 'description',
  },
  6: {
    component: ContactDetailsStep,
    displayedStep: 3,
    isNextButtonDisabled: false,
    name: 'contact-details',
  },
  7: {
    component: ArrivalStep,
    displayedStep: 4,
    isNextButtonDisabled: (state) => !(state.arrivalWindow.date && state.arrivalWindow.time),
    name: 'booking',
  },
  8: {
    component: ConfirmBookingStep,
    displayedStep: 5,
    isNextButtonDisabled: false,
    name: 'confirmation',
  },
};

export const HOMEOWNER_FLOW_LAST_STEP = Object.keys(HOMEOWNER_FLOW_STEP_MAP).length;
